import styled from 'styled-components';
import { FontSizeProps, fontSize, PaddingProps, padding, MarginProps, margin } from 'styled-system';
import { Flex, themeGet } from '@packages/ui';

export const StyledCTAWrapper = styled.div`
  padding-top: ${themeGet.space(2)};
`;

export const StyledTextRow = styled(Flex)<FontSizeProps & { color: string }>`
  ${fontSize}
  text-align: left;
  color: ${(props) => props.color}};
`;

export const StyledTitle = styled(StyledTextRow)`
  font-family: ${themeGet.fonts('brandSecondary')};
  font-weight: ${themeGet.fontWeight('semibold')};
`;

export const StyledSubitle = styled(StyledTextRow)`
  font-family: ${themeGet.fonts('brand')};
  font-weight: ${themeGet.fontWeight('lighter')};
`;

export const StyledInnerWrapper = styled.div<PaddingProps & MarginProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 100%;
  ${padding}
  ${margin}
`;
